import React, { useContext } from 'react'
import { UserContext } from '../App'
import Footer from '../components/Footer'
import Header from '../components/Header'
import MenuNotification from '../components/MenuNotification'
import MenuSidebar from '../components/MenuSidebar'

function Account() {
    const { mode } = useContext(UserContext)
    return (
        <div className='t1'>
            <div className='page'>
                <div className="page-content footer-clear">
                    <Header />
                    <div className="card card-fixed">
                        <div className="card-center mx-3 px-4 py-4 rounded-m">

                            <p className="input-title mb-2 font-14" style={{ color: "white" }}>Full Name :</p>
                            <div className="form-custom form-label form-icon mb-3 bg-transparent">
                                <input type="text" className="form-control rounded-xs" id="c1a" disabled placeholder="Full Name" />
                                <label htmlFor="c1a" className="color-theme">Full Name</label>
                                <span>(required)</span>
                            </div>

                            <p className="input-title mb-2 font-14" style={{ color: "white" }}>Bank Name:</p>
                            <div className="form-custom form-label form-icon mb-3 bg-transparent">
                                <input type="text" className="form-control rounded-xs" id="c1a" disabled placeholder="Bank" />
                                <label htmlFor="c1a" className="color-theme">Bank Name</label>
                                <span>(required)</span>
                            </div>

                            <p className="input-title mb-2 font-14" style={{ color: "white" }}>Bank Acoount No :</p>
                            <div className="form-custom form-label form-icon mb-3 bg-transparent">
                                <input type="text" className="form-control rounded-xs" id="c1a" disabled placeholder="Bank Account" />
                                <label htmlFor="c1a" className="color-theme">Bank Account No.</label>
                                <span>(required)</span>
                            </div>
                            <label className="form-check-label font-12 color_yellow" htmlFor="c2a">Remarks : For security purposes, please contact us to modify  any of information above.</label>
                            {/* <div className="d-flex align-items-center flex-column my-5">
                                <i className="fa-brands fa-whatsapp color-dark-green fa-3x" style={{ color: "#25D366" }}></i>
                                <h3>Live chat support</h3>
                            </div> */}
                        </div>
                        {mode === "light-mode" && <div className={`card-overlay rounded-0 m-0 bg-black-light opacity-70`}></div>}
                    </div>
                </div>
                <Footer />
                <MenuNotification />
                <MenuSidebar />
            </div>
        </div>
    )
}

export default Account